export default __webpack_public_path__ + "static/media/area-26.a80d0f85.jpg";